import { Logo } from '@vake/ui-kit';
import { FC } from 'react';

export type Props = {
    width?: number;
    animation?: 'bounce' | 'pulse';
};

export const Loader: FC<Props> = ({ width, animation = 'bounce' }) => {
    return (
        <div className={animation === 'bounce' ? 'animate-bounce' : 'animate-pulse'}>
            <Logo width={width || 128} />
        </div>
    );
};
